import React from "react";

export const ModalDetalleMensajesEnviados = ({ datos, onClose, tipoMensaje }) => {
    if (!datos) return null;

    // Convertir string JSON a objeto
    let datosObj = {};
    try {
        datosObj = JSON.parse(datos);
    } catch (error) {
        console.error("Error al parsear datos:", error);
        return <div>Error al mostrar los detalles</div>;
    }

    // Desestructurar los datos
    const { 1: cliente, 2: documento, 3: fechaFactura, 4: precio } = datosObj;

    const capitalizeWords = (str) => {
        return str
            ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
            : "";
    };
    console.log(tipoMensaje)
    // Crear array dinámico de labels y valores según tipoMensaje
    let detalles = [];
    if (tipoMensaje === "CT") {
        detalles = [
            { label: "Cliente", value: capitalizeWords(cliente) },
            { label: "Cotizaciones", value: documento },
            { label: "Fecha de Factura", value: fechaFactura },
            { label: "Precio", value: `$${precio}` },
        ];
    } else if (tipoMensaje === "GT" || tipoMensaje === "GD") {
        detalles = [
            { label: "Cliente", value: capitalizeWords(cliente) },
            { label: "Fecha de Factura", value: documento }, // aquí cambias 'documento' a 'fecha' según ejemplo
            { label: "Modelo", value: fechaFactura },
        ];
    } else if (tipoMensaje === "MT") {
        detalles = [
            { label: "Cliente", value: capitalizeWords(cliente) },
            { label: "Modelo", value: documento }, // aquí cambias 'documento' a 'fecha' según ejemplo
            { label: "Hora", value: fechaFactura },
            { label: "Opciones", value: precio }
        ];
    } else if (tipoMensaje === "CV" || tipoMensaje === "CP") {
        detalles = [
            { label: "Cliente", value: capitalizeWords(cliente) },
            { label: "Monto", value: `$${documento}` }, // aquí cambias 'documento' a 'fecha' según ejemplo
            { label: "Referencia", value: fechaFactura },
        ];
    } else {
        // Default si tipoMensaje no coincide
        detalles = [
            { label: "Cliente", value: capitalizeWords(cliente) },
            { label: "Documento", value: documento },
            { label: "Fecha de Factura", value: fechaFactura },
            { label: "Precio", value: `$${precio}` },
        ];
    }

    return (
        <div className="detalle-modal-overlay">
            <div className="detalle-modal">
                <button className="detalle-modal-close" onClick={onClose}>
                    X
                </button>
                <div className="plantilla-screen-titulo">
                    <div className="plantilla-screen-header">
                        <div className="plantilla-screen-header-titulo">Detalle</div>
                    </div>
                    <div className="plantilla-screen-efecto">
                        <div className="plantilla-screen-efecto-bl"></div>
                        <div className="plantilla-screen-efecto-circle"></div>
                        <div className="plantilla-screen-efecto-br"></div>
                    </div>
                </div>
                <div className="detalle-modal-content">
                    {detalles.map((item, index) => (
                        <p key={index}>
                            <strong>{item.label}:</strong> {item.value}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};